import { Outlet, useLocation } from 'react-router-dom';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import BackButton from 'components/BackButton';
import { ROUTE_PATHS } from 'routes/constants';

const Counterparties = () => {
  const location = useLocation();

  return (
    <section className={'right-section'}>
      {location.pathname !== ROUTE_PATHS.COUNTERPARTIES && <BackButton />}
      <Outlet />
    </section>
  );
};

Counterparties.propTypes = {
  counterpartiesStore: MobXPropTypes.observableObject
};

export default inject((stores) => ({
  counterpartiesStore: stores.counterpartiesStore
}))(observer(Counterparties));
